import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { HeadingF } from 'DesignSystem/Typography';
import ModalIcon from 'DesignSystem/FormSwiftModal/ModalIcon';


const getIcons = (modalIcon, iconClassName, orientation) => ({
  TopIcon: () => {
    const topModalIcon = {
      ...modalIcon,
      className: classNames(
        'ds-modal-icon-top',
        iconClassName,
      ),
    };
    return (
      (modalIcon && orientation === 'top') ? <ModalIcon {...topModalIcon} /> : null
    );
  },
  BottomIcon: () => {
    const bottomModalIcon = {
      ...modalIcon,
      className: classNames(
        'ds-modal-icon-bottom',
        iconClassName,
      ),
    };
    return (
      (modalIcon && orientation === 'bottom') ? <ModalIcon {...bottomModalIcon} /> : null
    );
  },
});

const ModalHeader = (props) => {
  const {
    headerCopy,
    iconOrientation,
    modalIcon,
  } = props;

  const { TopIcon, BottomIcon } = getIcons(modalIcon, modalIcon.className, iconOrientation);
  const Header = useCallback(
    () => (
      headerCopy ? <HeadingF className="ds-modal-header">{headerCopy}</HeadingF> : null
      ), [headerCopy],
  );

  return (
    <div className="ds-modal-header-container">
      <TopIcon />
      <Header />
      <BottomIcon />
    </div>
  );
};

ModalHeader.defaultProps = {
  headerCopy: '',
  iconOrientation: 'top',
  modalIcon: {},
};

ModalHeader.propTypes = {
  headerCopy: PropTypes.string,
  iconOrientation: PropTypes.string,
  modalIcon: PropTypes.shape({
    alt: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string,
  }),
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalHeader.jsx